import clsx from "clsx";
import type { ReactNode } from "react";
import React from "react";
import { useConstructionItems } from "~/hooks/useConstructionItems";
import type { ConstructionItem } from "~/models/ConstructionItem";
import Styles from "./ConstructionItemSettingList.module.scss";
import { ConstructionItemSettingListRow } from "./ConstructionItemSettingListRow";

export function ConstructionItemSettingList() {
	const { data: constructionItems } = useConstructionItems().index();
	const renderItemSettings = React.useCallback(
		(constructionItem: ConstructionItem): ReactNode => (
			<ConstructionItemSettingListRow
				constructionItem={constructionItem}
				key={constructionItem.id}
			/>
		),
		[]
	);

	if (constructionItems === null) {
		return null;
	}

	return (
		<div>
			<table className={Styles.List}>
				<thead>
					<tr className={clsx(Styles.ListRow, Styles.Header)}>
						<th>項目名</th>
						<th>単価</th>
					</tr>
				</thead>
				<tbody>{constructionItems.map(renderItemSettings)}</tbody>
			</table>
		</div>
	);
}
